// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGDownCaret = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#downCaret__clip0_12_2697)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.67 7h-.008c-.737 0-1.403.302-1.883.788-.482.49-.78 1.166-.78 1.91 0 .742.298 1.416.782 1.909l13.334 13.516c.48.489 1.147.79 1.885.79.739 0 1.405-.302 1.886-.79L31.22 11.607c.483-.491.78-1.167.78-1.91 0-.743-.297-1.418-.78-1.909-.48-.486-1.144-.787-1.88-.788H2.67z"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "downCaret__clip0_12_2697",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })
  })]
}));
SVGDownCaret.displayName = 'SVGDownCaret';
export default SVGDownCaret;